import React from 'react'
import uniqueId from 'lodash/uniqueId'

const InputCheck: React.FC<InputCheckProps> = ({
  label,
  register,
  error,
  rules,
  classes,
  name,
  helperFunction = () => {},
  labelClasses,
  value = false,
  ...props
}) => {
  const randomId = uniqueId('label-')

  return (
    <div className={`flex items-start ${classes}`}>
      <div className="flex items-center">
        <input
          checked={value}
          id={randomId}
          name={name}
          type="checkbox"
          ref={register ? register(rules) : undefined}
          onChange={(e) => helperFunction(e.target.checked)}
          {...props}
          className="h-4 w-4 cursor-pointer border-gray-300 rounded checked:bg-blue-500 checked:border-transparent dark:bg-black"
        />
      </div>
      {label && (
        <div className="ml-2 text-xs font-medium">
          <label
            htmlFor={randomId}
            className={`${labelClasses} text-primary-900 dark:text-white`}
          >
            {label}
          </label>
        </div>
      )}
    </div>
  )
}

export default InputCheck

type InnerProps = JSX.IntrinsicElements['input']

interface InputCheckProps {
  label?: string
  classes?: string
  labelClasses?: string
  innerProps?: InnerProps
  [key: string]: any
  value?: boolean
  helperFunction?: Function
}
